import { WalletClient } from 'viem';

type walletClientState = WalletClient | (() => WalletClient);

function initWalletClient() {
  let walletClient: walletClientState | undefined;

  function getWalletClient(): WalletClient {
    if (!walletClient) {
      throw new Error('WalletClient is not defined.');
    }

    if (typeof walletClient === 'function') {
      return walletClient();
    }

    return walletClient;
  }

  function setWalletClient(client: walletClientState) {
    walletClient = client;
  }

  return {
    getWalletClient,
    setWalletClient,
  };
}

export const { getWalletClient, setWalletClient } = initWalletClient();
